import styled from 'styled-components';

const Custom404TemplateStyle = styled.section`
	--errorTitleSize: var(--sp20x);

	--largeDistance: var(--sp6x);
	--smallDistance: var(--sp4x);

	height: calc(100vh - var(--headerFixedHeight));

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.inner-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.error-title {
		font-size: var(--errorTitleSize);
	}

	.error-subtitle {
		margin-top: var(--largeDistance);
	}

	.error-description {
		margin-top: var(--smallDistance);
	}

	.error-btn {
		margin-top: var(--largeDistance);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--errorTitleSize: var(--sp15x);

		--largeDistance: var(--sp5x);
		--smallDistance: var(--sp3x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--errorTitleSize: var(--sp13x);

		--largeDistance: var(--sp4x);
		--smallDistance: var(--sp2-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--errorTitleSize: var(--sp12x);

		--largeDistance: var(--sp4x);
		--smallDistance: var(--sp2-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--errorTitleSize: var(--sp11x);

		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--errorTitleSize: var(--sp9x);

		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--errorTitleSize: var(--sp9x);

		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--errorTitleSize: var(--sp8x);

		--largeDistance: var(--sp3x);
		--smallDistance: var(--sp2x);
	}
`;

export default Custom404TemplateStyle;
